import React from "react";
import MNPUserAPP from "./MNPUserApp";
export default {
  routeProps: {
    path: "/*",
    element: <MNPUserAPP />,
  },
  name: "MNP User",
};
